module.exports = __webpack_public_path__ + "cancellara-dist/img/gift-card.e2f3bd49.png";